// schemas.ts
import z from 'zod';

export const PrePostagemSchema = z.object({
  codigoServico: z.string().min(1, 'Código do serviço é obrigatório'),
  tipoPostagem: z.string().optional(),
  codigoObjeto: z.string().optional(),

  comprimentoInformado: z.string().min(1, 'Comprimento do objeto é obrigatório'),
  larguraInformada: z.string().min(1, 'Largura do objeto é obrigatória'),
  alturaInformada: z.string().min(1, 'Altura do objeto é obrigatória'),
  diametroInformado: z.string().optional(),
  pesoInformado: z.string().min(1, 'Peso é obrigatório'),

  operacao: z.object({
    tipoEntrada: z.string().min(1, 'Tipo de entrada é obrigatório'),
    formaEntrada: z.string().min(1, 'Forma de entrada é obrigatória'),
    referencia: z.string().optional(),
  }),
  precoPrePostagem: z.string().optional(),
  logisticaReversa: z.boolean(),

  remetente: z.object({
    nome: z.string().min(1, 'Nome é obrigatório'),
    cpfCnpj: z.string().min(11, 'CPF ou CNPJ inválido'),
    email: z.string().email('E-mail inválido'),
    telefone: z.string().min(9, 'Telefone é obrigatório'),
    celular: z.string().optional(),
    endereco: z.object({
      cep: z.string().min(8, 'CEP inválido'),
      logradouro: z.string().min(1, 'Logradouro é obrigatório'),
      complemento: z.string().optional().or(z.literal('')),
      numero: z.string().min(1, 'Número é obrigatório'),
      bairro: z.string().min(1, 'Bairro é obrigatório'),
      cidade: z.string().min(1, 'Cidade é obrigatória'),
      uf: z.string().length(2, 'UF deve ter 2 caracteres'),
    }),
  }),

  destinatario: z.object({
    nome: z.string().min(1, 'Nome é obrigatório'),
    cpfCnpj: z.string().min(11, 'CPF ou CNPJ inválido'),
    email: z.string().email('E-mail inválido'),
    telefone: z.string().min(9, 'Telefone é obrigatório'),
    celular: z.string().optional(),
    endereco: z.object({
      cep: z.string().min(8, 'CEP inválido'),
      logradouro: z.string().min(1, 'Logradouro é obrigatório'),
      complemento: z.string().optional().or(z.literal('')),
      numero: z.string().min(1, 'Número é obrigatório'),
      bairro: z.string().min(1, 'Bairro é obrigatório'),
      cidade: z.string().min(1, 'Cidade é obrigatória'),
      uf: z.string().length(2, 'UF deve ter 2 caracteres'),
    }),
  }),

  itensDeclaracaoConteudo: z.array(
    z.object({
      conteudo: z.string().min(1, 'Conteúdo é obrigatório'),
      quantidade: z.string().min(1, 'Quantidade é obrigatória'),
      valor: z.string().min(1, 'Valor é obrigatório'),
    })
  ),
  numeroNotaFiscal: z.string().optional(),
  chaveNFe: z.string().optional(),

  prazoPostagem: z.string().min(1, 'Prazo é obrigatório'),
  dataValidade: z.string().min(1, 'Data de validade é obrigatória'),
  observacao: z.string().optional(),

  estabelecimento: z.string().optional(),
  motivoDevolucao: z.string().optional(),
  campoFormaEntrada: z.string().optional(),
});

export type TPrePostagemSchema = z.infer<typeof PrePostagemSchema>;
